import React from 'react';
import "./DnsList.css";
import PeriodicElementSimple from "./PeriodicElementSimple";

const DNS_LINKS = [
    { href: 'http://cloud.ksuto.fr', color: '#0082C9', element: 'Ne', number: '1', label: 'xtCloud' },
    { href: 'http://home.ksuto.fr', color: '#96C927', element: 'Ho', number: '2', label: 'me assistant' },
    { href: 'http://emby.ksuto.fr', color: '#E5A00D', element: 'Em', number: '3', label: 'by' },
    { href: 'http://bitwarden.ksuto.fr', color: '#858585', element: 'Bi', number: '4', label: 'tWarden' },
    { href: 'https://ksuto.grafana.net/goto/6dWzLcfVk?orgId=1', color: '#D40000', element: 'Su', number: '5', label: 'pervision' },
];

const DnsList = () => {
    return (
        <div className="DnsList">
            <ul>
                {DNS_LINKS.map((link) => (
                    <li key={link.href}>
                        <a href={link.href}>
                            <PeriodicElementSimple
                                size={50}
                                color={link.color}
                                element={link.element}
                                number={link.number}
                            />
                            {link.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DnsList;